export const contacts = [
  {
    name: 'pages/Contact.culture_nature_reserve2',
    address: 'pages/Contact.district_province2',
    email: 'dongnaibr@gmail.com',
    phone: '012345678',
    img: './contact/contact2.jpg',
  },
];
